import { render, staticRenderFns } from "./TheSignInFormBS46.vue?vue&type=template&id=90ecc60c&scoped=true"
import script from "./TheSignInFormBS46.vue?vue&type=script&lang=js"
export * from "./TheSignInFormBS46.vue?vue&type=script&lang=js"
import style0 from "./TheSignInFormBS46.vue?vue&type=style&index=0&id=90ecc60c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ecc60c",
  null
  
)

export default component.exports